module.exports = __webpack_public_path__ + "media/images/square-gift-cd3d2926f23f43c68d50ff1cbc161c5b.png";